import { Link } from 'react-router-dom';
import { Shield, Twitter, Github, Mail, ExternalLink } from 'lucide-react';

export default function Footer() {

  const footerLinks = {
    product: [
      { label: 'Dashboard', to: '/dashboard' },
      { label: 'Privacy Toolkit', to: '/toolkit' },
      { label: 'AI Assistant', to: '/chat' },
      { label: 'Premium Services', to: '/premium' },
      { label: 'Pricing', to: '/pricing' },
    ],
    resources: [
      { label: 'Privacy News', to: '/news' },
      { label: 'Community Forum', to: '/forum' },
      { label: 'Protection Guides', to: '/toolkit' },
      { label: 'Blog', to: '/blog' },
    ],
    company: [
      { label: 'About Us', to: '/about' },
      { label: 'Contact', to: '/contact' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Terms of Service', to: '/terms' },
    ],
  };

  return (
    <footer className="bg-[#050505] border-t border-[#262626] py-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 rounded-lg bg-[#00FF94]/10 border border-[#00FF94]/20 flex items-center justify-center">
                <Shield className="w-5 h-5 text-[#00FF94]" />
              </div>
              <span className="font-heading font-bold text-xl text-white">
                Privacy<span className="text-[#00FF94]">Shield</span>
              </span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed mb-6 max-w-sm">
              Empowering individuals to take control of their digital privacy. 
              Counter surveillance, protect your data, and reclaim your digital freedom.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="#" 
                className="w-10 h-10 rounded-lg bg-[#0a0a0a] border border-[#262626] flex items-center justify-center text-gray-500 hover:text-[#00FF94] hover:border-[#00FF94]/30 transition-colors"
                data-testid="social-twitter"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-lg bg-[#0a0a0a] border border-[#262626] flex items-center justify-center text-gray-500 hover:text-[#00FF94] hover:border-[#00FF94]/30 transition-colors"
                data-testid="social-github"
              >
                <Github className="w-4 h-4" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-lg bg-[#0a0a0a] border border-[#262626] flex items-center justify-center text-gray-500 hover:text-[#00FF94] hover:border-[#00FF94]/30 transition-colors"
                data-testid="social-mail"
              >
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">Product</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.to} 
                    className="text-gray-500 hover:text-[#00FF94] text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.label}>
                  {link.external ? (
                    <a 
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-500 hover:text-[#00FF94] text-sm transition-colors flex items-center gap-1"
                    >
                      {link.label}
                      <ExternalLink className="w-3 h-3" />
                    </a>
                  ) : (
                    <Link 
                      to={link.to} 
                      className="text-gray-500 hover:text-[#00FF94] text-sm transition-colors"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4 text-sm uppercase tracking-wider">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.to} 
                    className="text-gray-500 hover:text-[#00FF94] text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#262626] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-sm">
            © sseba-alek. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs font-mono">
            Built to counter digital surveillance
          </p>
        </div>
      </div>
    </footer>
  );
}
